export const NavigateToTopElements = {
	navigateToTopLink: 'navigate_to_top',
};
